import { render, staticRenderFns } from "./WorkerList.vue?vue&type=template&id=58d486fb"
import script from "./WorkerList.vue?vue&type=script&lang=js"
export * from "./WorkerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports